
import VwAporteService from '../../../business-api/VwAporteService'

import {
    mensagemErroErro
} from '../../../business-components/Toastr/Toastr'



export const getAporteList = async ( variaveisGlobais, iClienteNull, dataPrevistaAporteNull ) => {

    const vwAporteService = new VwAporteService()

    try {
        const response = await vwAporteService.buscarAporteList(variaveisGlobais, iClienteNull, dataPrevistaAporteNull)

        return response.data

    } catch (erro) {

        mensagemErroErro(erro)
        
        return []
    }
}



export const getSumAporte = async ( variaveisGlobais, tipoSum, dataInicial, dataFinal ) => {

    const vwAporteService = new VwAporteService()

    try {
        const response = await vwAporteService.sumAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal)

        return response.data

    } catch (erro) {

        mensagemErroErro(erro)
        
        return []
    }
}



export const getSumDataAporte = async ( variaveisGlobais, tipoSum, dataInicial, dataFinal ) => {

    const vwAporteService = new VwAporteService()

    try {
        const response = await vwAporteService.sumDataAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal)

        return response.data

    } catch (erro) {

        mensagemErroErro(erro)
        
        return []
    }
}



export const putAporteList = async ( variaveisGlobais, aporteList ) => {

    const vwAporteService = new VwAporteService()

    try {

        await vwAporteService.putAporteList(variaveisGlobais, aporteList)

        return true

    } catch (erro) {

        mensagemErroErro(erro)

        return false
    }
}